import { createElement } from 'react';
import { createRoot } from 'react-dom/client';

import type { AdminLoginProps } from '@/types/pages';

import { initI18n, transformLocales } from '@/helpers';

import { log_in } from '@/localization';

import { AdminLogin } from '@/pages/admin/log_in';

export const renderAdminLogin = (
  pageContainer = document.getElementById('page-content'),
  renderContainer = document.getElementById('page-root'),
) => {
  const props = JSON.parse(
    pageContainer?.getAttribute('data') || '{}',
  ) as AdminLoginProps;

  initI18n(transformLocales(log_in));

  createRoot(renderContainer!).render(createElement(AdminLogin, props));
};
